// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__EBQAX","tab":"Tabs_tab__RYrW7","isActive":"Tabs_isActive__2AIFM","badge":"Tabs_badge__Ms19P","warning":"Tabs_warning__Fzcee"};